import * as React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import './ProductsTable.scss';
import ProductRow from '../ProductRow';
import '../ProductRow/ProductRow.scss';
import { Button, EButtonType } from '@repo/apg-ui';
import { replaceUmlauts } from '../../utils/react';
import { ReactComponent as ArrowUp } from '../../assets/icons/arrow_long.svg';
import { SchemaPossibleBookingDates, SchemaProduct, SchemaProductGroupNode } from '@repo/legacy-commerce-api';
import { PartiallyIntegratedUserDataEC } from '../../reducers/app';

interface IProps {
  activateTab?: any;
  basketEntries?: any;
  basketId?: string;
  changeProductDate?: any;
  deselectAll?: any;
  getProductPrice?: any;
  updateDateAndDuration?: any;
  getAvailabilityForDigitalProduct?: any;
  handleProductSelectClick: any;
  hasInvalidProducts?: boolean;
  loading?: { [key: string]: any };
  journey2?: boolean;
  userBasket?: boolean;
  onChange: any;
  possibleBookingDates?: SchemaPossibleBookingDates;
  productsNested: SchemaProductGroupNode[];
  productsJ2ByUrn?: Record<string, SchemaProduct>;
  selectAll?: any;
  sortChanged?: any;
  sort: { [k: string]: any };
  currentSort: string;
  userDataEC: PartiallyIntegratedUserDataEC;
  tabJ1?: number;
  tabJ2?: number;
  isShowRemoveAction?: boolean;
  onRemoveCallback?: any;
  isDigiflex?: boolean;
  isHideAddingRemoval?: boolean;
}

interface IState {
  currentlyVisible: { [k: string]: any };
  currentlyVisibleJ1: { [k: string]: any };
  selected: any;
}

const step = 10;

class ProductsTable extends React.Component<IProps, IState> {
  constructor(props?: any) {
    super(props);
    const currentlyVisibleJ1 = {};

    if (
      this.props.productsNested &&
      this.props.productsNested[this.props.tabJ1] &&
      this.props.productsNested[this.props.tabJ1].subgroup?.elements.length > 0
    ) {
      this.props.productsNested[this.props.tabJ1].subgroup.elements.forEach((el) => {
        currentlyVisibleJ1[replaceUmlauts(el.groupvalue)] = 2;
      });
    }

    this.state = {
      selected: [],
      currentlyVisible: this.setNewCurrentlyVisibleCounter(true),
      currentlyVisibleJ1: currentlyVisibleJ1,
    };
  }

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if (prevProps.productsNested !== this.props.productsNested && !!this.props.productsNested) {
      this.setNewCurrentlyVisibleCounter();
    }
  }

  setNewCurrentlyVisibleCounter = (callInConstructor: boolean = false) => {
    const { productsNested, journey2 } = this.props;
    const currentlyVisible = {};

    if (journey2 && productsNested && productsNested.length > 0) {
      productsNested.forEach((el) => (currentlyVisible[replaceUmlauts(el.groupvalue)] = 2));
    }

    if (callInConstructor) {
      return currentlyVisible;
    }

    this.setState({ currentlyVisible });
  };

  getBasketEntryByProduct = (basketEntries: any[] | undefined, product: any) => {
    if (!basketEntries) {
      return undefined;
    }
    let index = product.basketkey;
    if (!index) {
      index = `${product.producturn}_${product.startdate.split('T')[0]}`;
    }
    return basketEntries[index];
  };

  render() {
    const {
      productsNested,
      journey2,
      tabJ1,
      loading,
      currentSort,
      sort,
      sortChanged,
      basketEntries,
      userDataEC,
      isShowRemoveAction,
      isDigiflex,
      productsJ2ByUrn,
    } = this.props;
    const { currentlyVisible, currentlyVisibleJ1 } = this.state;

    return (
      <div
        className={classNames('products-table', {
          calendarLoading: loading?.calendar,
        })}
      >
        <div className='products-table-content'>
          {productsNested &&
            (journey2
              ? productsNested.map((format: SchemaProductGroupNode, idx: number) => {
                  // @ts-expect-error SchemaGroupedProduct does not specify Product on this level:
                  const totalFormatProducts = format.products.length;
                  const currentlyVisibleNo = currentlyVisible[replaceUmlauts(format.groupvalue)] || null;

                  if (!currentlyVisibleNo || totalFormatProducts === 0) {
                    return null;
                  }

                  let lastProduct = null;

                  return (
                    <div className='' key={replaceUmlauts(format.groupvalue) + '_' + idx}>
                      {
                        // @ts-expect-error SchemaGroupedProduct does not specify Product on this level:
                        format.products.map((product: SchemaProduct, index: number) => {
                          // let sum = (currentlyVisibleNo || step) + step;
                          // const count = sum <= totalFormatProducts ? sum : totalFormatProducts;

                          // J2
                          if (index < currentlyVisibleNo) {
                            const productRow = (
                              <ProductRow
                                activateSourceTab={() => {
                                  this.props.activateTab?.(this.props.tabJ2);
                                }}
                                basketEntries={basketEntries}
                                key={`productRow${product.basketkey || product.producturn}`}
                                duration={userDataEC?.duration || 7}
                                startDate={
                                  userDataEC?.startDate ||
                                  userDataEC.basketProducts.productsByUrn[product.producturn]?.startdate
                                }
                                getProductPrice={this.props.getProductPrice}
                                getAvailabilityForDigitalProduct={this.props.getAvailabilityForDigitalProduct}
                                changeProductDate={this.props.changeProductDate}
                                updateDateAndDuration={this.props.updateDateAndDuration}
                                possibleBookingDates={this.props.possibleBookingDates}
                                product={product}
                                loading={loading}
                                productNew={this.getBasketEntryByProduct(basketEntries, product)}
                                journey2={journey2}
                                productsJ2ByUrn={productsJ2ByUrn}
                                handleSelectionClick={(product, value, newProductData?) => {
                                  return (
                                    this.props.handleProductSelectClick &&
                                    this.props
                                      .handleProductSelectClick(product, value, newProductData)
                                      .catch((err) => console.error(err))
                                  );
                                }}
                                userDataEC={userDataEC}
                                isShowRemoveAction={isShowRemoveAction}
                                isDigiflex={product.producttype === 'digital'}
                                isShortTimeslot={false}
                                isHideAddingRemoval={this.props.isHideAddingRemoval}
                                isSecondProduct={false}
                              />
                            );
                            lastProduct = product;
                            return productRow;
                          } else if (index === currentlyVisibleNo) {
                            return (
                              <div className='p-4' key={`productRow${product.basketkey || product.producturn}`}>
                                <p className='w-100 text-center mini-text'>
                                  <FormattedMessage
                                    id='ec.components.productsTable.showingXfromZ'
                                    defaultMessage='Zeigt {showingNow} von {totalNumber} an'
                                    values={{
                                      showingNow: currentlyVisibleNo,
                                      totalNumber: totalFormatProducts,
                                    }}
                                  />
                                </p>

                                <Button
                                  className='mx-auto d-block mt-4'
                                  buttonType={EButtonType.InvertedPillMedium}
                                  onClick={() => {
                                    this.setState({
                                      currentlyVisible: {
                                        ...currentlyVisible,
                                        [replaceUmlauts(format.groupvalue)]: totalFormatProducts,
                                      },
                                    });
                                  }}
                                >
                                  {
                                    <FormattedMessage
                                      id='ec.components.productsTable.showMore'
                                      defaultMessage='Mehr anzeigen'
                                    />
                                  }
                                </Button>
                              </div>
                            );
                          } else {
                            return null;
                          }
                        })
                      }

                      {currentlyVisibleNo === totalFormatProducts && totalFormatProducts !== 2 && (
                        <div>
                          <p className='w-100 text-center'>
                            <FormattedMessage
                              id='ec.components.productsTable.showingXfromZ'
                              defaultMessage='Zeigt {showingNow} von {totalNumber} an'
                              values={{
                                showingNow: totalFormatProducts,
                                totalNumber: totalFormatProducts,
                              }}
                            />
                          </p>
                          <Button
                            className='mx-auto d-block my-4'
                            buttonType={EButtonType.InvertedPillMedium}
                            onClick={() => {
                              this.setState({
                                currentlyVisible: {
                                  ...currentlyVisible,
                                  [replaceUmlauts(format.groupvalue)]: 2,
                                },
                              });
                            }}
                          >
                            <FormattedMessage
                              id='ec.components.productsTable.showLess'
                              defaultMessage='Weniger anzeigen'
                            />
                          </Button>
                        </div>
                      )}
                    </div>
                  );
                })
              : productsNested[tabJ1] &&
                productsNested[tabJ1].subgroup.elements.map((format: any, idx: number) => {
                  const totalFormatProducts = format.products.length;
                  const currentlyVisibleNo = currentlyVisibleJ1[replaceUmlauts(format.groupvalue)] || 1e6;

                  return (
                    <div className='' key={replaceUmlauts(format.groupvalue) + '_' + idx}>
                      <div
                        className={classNames('product-row-header', {
                          priceSorted: currentSort === 'price',
                          nameSorted: currentSort === 'name',
                        })}
                      >
                        <div className='product-row-column-first product-row-first fw-bold'>{format.groupvalue}</div>

                        <div className='product-row-column-first' />

                        <div className='product-row-column-first termin fw-bold'>
                          <FormattedMessage id='ec.components.productsTable.termin' defaultMessage='Zeitraum' />
                        </div>

                        <div className='product-row-column-first fw-bold red name'>
                          <div className='d-flex pointer' onClick={() => sortChanged('name')}>
                            <ArrowUp
                              className={classNames('me-4', {
                                rotate180: sort.name === 1,
                              })}
                            />

                            <FormattedMessage id='ec.components.productsTable.adresse' defaultMessage='Adresse' />
                          </div>
                        </div>

                        <div className='product-row-column-first fw-bold red price'>
                          <div className='d-flex pointer' onClick={() => sortChanged('price')}>
                            <ArrowUp
                              className={classNames('me-4', {
                                rotate180: sort.price === 1,
                              })}
                            />

                            <FormattedMessage id='ec.components.productsTable.chf' defaultMessage='CHF' />
                          </div>
                        </div>

                        <div className='product-row-column-first d-flex customCheckbox fw-bold text-right'>
                          <FormattedMessage id='ec.components.productsTable.selectProduct' defaultMessage='Auswählen' />
                        </div>
                      </div>

                      {format.products.map((product, index) => {
                        let sum = (currentlyVisibleNo || step) + step;
                        const count = sum <= totalFormatProducts ? sum : totalFormatProducts;

                        if (index < currentlyVisibleNo) {
                          // J1
                          return (
                            <ProductRow
                              basketEntries={basketEntries}
                              changeProductDate={this.props.changeProductDate}
                              duration={userDataEC?.duration}
                              getAvailabilityForDigitalProduct={this.props.getAvailabilityForDigitalProduct}
                              getProductPrice={this.props.getProductPrice}
                              journey2={journey2}
                              key={`productRow${product.basketkey || product.producturn}`}
                              loading={loading}
                              possibleBookingDates={this.props.possibleBookingDates}
                              product={product}
                              productNew={this.getBasketEntryByProduct(basketEntries, product)}
                              startDate={userDataEC?.startDate}
                              updateDateAndDuration={this.props.updateDateAndDuration}
                              handleSelectionClick={(product, value, newProductData?) => {
                                return this.props.handleProductSelectClick(product, value, newProductData);
                              }}
                              userDataEC={userDataEC}
                              productsJ2ByUrn={productsJ2ByUrn}
                              isShowRemoveAction={false}
                              onRemoveCallback={this.props.onRemoveCallback}
                              isDigiflex={isDigiflex}
                              isShortTimeslot={false}
                              isHideAddingRemoval={this.props.isHideAddingRemoval}
                            />
                          );
                        } else if (index === currentlyVisibleNo) {
                          return (
                            <div key={`productRow${product.basketkey || product.producturn}`}>
                              <p className='w-100 text-center mini-text'>
                                <FormattedMessage
                                  id='ec.components.productsTable.showingXfromZ'
                                  defaultMessage='Zeigt {showingNow} von {totalNumber} an'
                                  values={{
                                    showingNow: currentlyVisibleNo,
                                    totalNumber: totalFormatProducts,
                                  }}
                                />
                              </p>

                              <Button
                                className='mx-auto d-block my-4'
                                buttonType={EButtonType.InvertedPillMedium}
                                onClick={() => {
                                  this.setState({
                                    currentlyVisibleJ1: {
                                      ...currentlyVisibleJ1,
                                      [replaceUmlauts(format.groupvalue)]: count,
                                    },
                                  });
                                }}
                              >
                                <FormattedMessage
                                  id='ec.components.productsTable.showMore'
                                  defaultMessage='Mehr anzeigen'
                                />
                              </Button>
                            </div>
                          );
                        } else {
                          return null;
                        }
                      })}

                      {currentlyVisibleNo === totalFormatProducts && totalFormatProducts !== 2 && (
                        <div>
                          <p className='w-100 text-center'>
                            <FormattedMessage
                              id='ec.components.productsTable.showingXfromZ'
                              defaultMessage='Zeigt {showingNow} von {totalNumber} an'
                              values={{
                                showingNow: totalFormatProducts,
                                totalNumber: totalFormatProducts,
                              }}
                            />
                          </p>

                          <Button
                            className='mx-auto d-block my-4'
                            buttonType={EButtonType.InvertedPillMedium}
                            onClick={() => {
                              this.setState({
                                currentlyVisibleJ1: {
                                  ...currentlyVisibleJ1,
                                  [replaceUmlauts(format.groupvalue)]: 2,
                                },
                              });
                            }}
                          >
                            <FormattedMessage
                              id='ec.components.productsTable.showLess'
                              defaultMessage='Weniger anzeigen'
                            />
                          </Button>
                        </div>
                      )}
                    </div>
                  );
                }))}
        </div>
      </div>
    );
  }
}

export default ProductsTable;
